let pageLoadNumber = -1;

export const getPageLoadNumber = (): number => pageLoadNumber;

export const setPageLoadNumber = (newPageLoadNumber: number): void => {
  pageLoadNumber = newPageLoadNumber;
};
